import * as React from "react";
import { DetailLayoutWrapper } from "../../components/sharedStyles";

import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import InvoiceRecordOverview from "./detail/Overview";

export default function MainInvoiceRecordDetail() {
  const { path, url } = useRouteMatch();

  const SUB_PAGES = [
    {
      path: "/overview",
      label: "Aviseringslogg",
      component: InvoiceRecordOverview,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
  }));

  return (
    <>
      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Aviseringslogg`}
          breadCrumbs={[
            {
              url: "/rental-notifications/failed-generations",
              label: "Misslyckade aviseringar",
            },
            { label: "Aviseringslogg" },
          ]}
          {...{ subPages: subPageLinks }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}
